export default __webpack_public_path__ + "static/media/sp_recomendation_table_comment.d89f06ca.svg";